import React from 'react';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import PendingAdditionalSignatures from "../RelationshipSignedStep/PendingAdditionalSignatures";
import AllSetPage from "./AllSetPage";
import { useCobConfig } from "../CobConfigContext";
export default function AllSetStep() {
  const {
    relationship
  } = useCobConfig();
  const {
    MULTIPLE_RECEPIENTS = false
  } = useFeatureFlags();
  return MULTIPLE_RECEPIENTS ? /*#__PURE__*/React.createElement(PendingAdditionalSignatures, null) : /*#__PURE__*/React.createElement(AllSetPage, {
    relationshipId: relationship.id
  });
}